(()=>{
 'use strict';
 const hover=matchMedia('(hover:hover) and (pointer:fine)');
 document.querySelectorAll('[data-equipment-nav]').forEach(group=>{
  const toggle=group.querySelector('[data-equipment-toggle]'),panel=group.querySelector('.equipment-dropdown');
  const links=[...panel.querySelectorAll('a')];let timer,pinned=false;
  const open=()=>{clearTimeout(timer);panel.hidden=false;toggle.setAttribute('aria-expanded','true')};
  const close=()=>{clearTimeout(timer);pinned=false;panel.hidden=true;toggle.setAttribute('aria-expanded','false')};
  toggle.addEventListener('click',()=>{if(!panel.hidden&&pinned)close();else{pinned=true;open()}});
  group.addEventListener('pointerenter',()=>{if(hover.matches)open()});
  group.addEventListener('pointerleave',()=>{if(hover.matches&&!pinned)timer=setTimeout(()=>{if(!group.contains(document.activeElement))close()},160)});
  group.addEventListener('focusout',()=>requestAnimationFrame(()=>{if(!group.contains(document.activeElement)&&!group.matches(':hover'))close()}));
  group.addEventListener('keydown',event=>{
   if(event.key==='Escape'&&!panel.hidden){event.preventDefault();event.stopPropagation();close();toggle.focus()}
   if(event.target===toggle&&['ArrowDown','ArrowUp'].includes(event.key)){event.preventDefault();open();links[event.key==='ArrowDown'?0:links.length-1].focus()}
  });
  document.addEventListener('click',event=>{if(!group.contains(event.target))close()});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden)close()});
  document.addEventListener('ghm:close-equipment-menus',close);
 });
})();
